import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import { ProductCard } from "./ProductCard";

export function CollectionPage() {
  const { category } = useParams(); 
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchProductsByCategory(category);
  }, [category]);

const fetchProductsByCategory = async (category) => {
  setLoading(true);
  try {
    const res = await axios.get("https://admin.bodiosyakdown.com/api/products");
    const allProducts = res.data;

    const filtered = allProducts.filter(
      (product) => product.category && product.category.toLowerCase() === category.toLowerCase()
    );

    setProducts(filtered);
  } catch (err) {
    console.error("Failed to fetch products:", err);
    setProducts([]);
  } finally {
    setLoading(false);
  }
};


  const categoryName = category ? category.charAt(0).toUpperCase() + category.slice(1) : '';
  const categoryDescription = category ? `Discover our collection of ${category} products.` : '';

  return (
    <div className="flex flex-col text-black pt-[145px] max-md:pt-[100px]">
      {/* Category Name */}
      <div className="self-center text-6xl text-center uppercase max-md:text-4xl">
        {categoryName}
      </div>

      {/* Description */}
      <section className="self-center mt-6 text-center w-full max-w-3xl px-4 font-light text-lg">
        {categoryDescription}
      </section>

      {/* Filter header */}
      <div className="flex justify-between items-center bg-gray-100 p-4 rounded-lg w-full max-w-[1700px] mx-auto mt-10 px-6">
        <h3 className="font-semibold text-lg">Filter</h3>
        <span className="font-semibold text-md">{products.length} Products</span>
      </div>

      {/* Product Grid */}
      {loading ? (
        <p className="text-center mt-10">Loading...</p>
      ) : products.length === 0 ? (
        <p className="text-center mt-10 text-xl">No products found in this category.</p>
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6 px-4 max-w-[1920px] mx-auto mt-8">
          {products.map((product) => {
            let imageData = null;
            
            if (product.optimizedImages && product.optimizedImages.length > 0) {
              const lgVariant = product.optimizedImages.find(img => img.variant === 'lg');
              if (lgVariant) {
                imageData = {
                  type: 'optimized',
                  avif: `https://bodiosyakdown.com${lgVariant.avif_url}`,
                  webp: `https://bodiosyakdown.com${lgVariant.webp_url}`,
                };
              }
            }
            if (!imageData && product.mainImage) {
              imageData = {
                type: 'original',
                url: `https://bodiosyakdown.com/uploads/${product.mainImage}`
              };
            }
            return (
              <ProductCard
                key={product.id}
                id={product.id}
                name={product.name}
                imageData={imageData} 
                price={product.price}
                altText={product.name}
                stock={product.stock}
                sku={product.sku}
                variantCode={product.variantCode}
                color={product.color}
                size={product.size}
                detail={product.detail}
              />
            );
          })}

        </div>
      )}
    </div>
  );
}
